type ResolveNextStepAdvanceArgs = {
  currentStep: number
  totalSteps: number
  step?: number
  navigate: (to: string) => void
  goToStep: (step: number) => void
  suppressNextSessionStepSync: () => void
}

export function resolveNextStepAdvance({
  currentStep,
  totalSteps,
  step,
  navigate,
  goToStep,
  suppressNextSessionStepSync
}: ResolveNextStepAdvanceArgs) {
  if (currentStep >= totalSteps - 1) {
    navigate('/thank-you')
    return
  }

  suppressNextSessionStepSync()

  if (typeof step === 'number') {
    goToStep(step + 1)
    return
  }

  goToStep(currentStep + 1)
}
